import { LocalDate, Month } from "@js-joda/core";
import { FormData2 } from "./GenericTable";
import { localDateToJSDate } from "../../../utils";

export const baseFormDefaults: FormData2 = {
  yearlyRule: {
    month: Month.JANUARY,
    day: 1,
    fromYear: LocalDate.now().year(),
    toYear: null,
  },
  scheduleType: "repeats",
  interval: 1,
  frequency: "monthly",
  weekday: null,
  monthlyRule: { type: "fixed-day", day: "1" },
  startsFrom: localDateToJSDate(LocalDate.now()),
  endsOn: null,
  taxProfileId: null,
  isTaxable: true,
  oneOffDates: [null],
  description: "",
  amount: null,
  parentalLeavePolicy: null,
  redundancy: null,
  bonuses: null,
};
